import { routeGo } from "@/hooks/web/jumpGo";
import { removeDashesFromDate } from "@/logic/home";
import { setQueryParamsFun } from "@/store/home";
import { getSelectCurrency } from "@/store/locale";

export const goJumpSearchResult = (requestData: any) => {
	const {
		adults,
		children,
		infant,
		cabinGrade,
		fromCityName,
		fromCityCode,
		toCityCode,
		toCityName,
		retDate,
		fromDate,
		tripType } = requestData;
	const url: string = 'flights/search/' + requestData.fromCityCode + '/' + requestData.toCityCode;
	const queryParam = {
		adults,
		children,
		infant,
		startDate: removeDashesFromDate(fromDate),
		endDate: retDate ? removeDashesFromDate(retDate) : '',
		tripType: tripType,
		seatClass: cabinGrade,
		currency: getSelectCurrency(),
	};
	if (tripType === 1) {
		// @ts-ignore
		delete queryParam['endDate'];
	}
	setQueryParamsFun({
		adultNum: adults,
		childNum: children,
		infantNum: infant,
		fromCity: {
			cityCode: fromCityCode,
			cityName: fromCityName,
		},
		toCity: {
			cityCode: toCityCode,
			cityName: toCityName,
		},
		fromDate: fromDate,
		retDate: retDate,
		cabinGrades: cabinGrade,
		tripType: tripType,
		fromCityInfo: requestData.fromCityInfo || {},
		toCityInfo: requestData.toCityInfo || {}
	});
	console.log(23232323);
	routeGo(url, '', queryParam);
};
